import { RandomGenerator } from '../../../test-utils/random-generators';
import { PluginType } from './plugin-type.enum';
var InstagramAccountBuilder = /** @class */ (function () {
    function InstagramAccountBuilder() {
        this.instagramPlugin = {
            account: {
                externalKey: RandomGenerator.randomId(),
                name: RandomGenerator.randomString(),
                creationDate: Date.now(),
                lastUpdateDate: Date.now(),
                type: PluginType.INSTAGRAM_ACCOUNT,
                data: {
                    directMessageEnabled: true,
                    profileImage: 'https://picsum.photos/200/300',
                    displayName: RandomGenerator.randomName(),
                }
            },
            valid: false
        };
    }
    InstagramAccountBuilder.prototype.withExternalKey = function (externalKey) {
        this.instagramPlugin.account.externalKey = externalKey;
        return this;
    };
    InstagramAccountBuilder.prototype.withName = function (name) {
        this.instagramPlugin.account.name = name;
        return this;
    };
    InstagramAccountBuilder.prototype.withCreationDate = function (date) {
        this.instagramPlugin.account.creationDate = date;
        return this;
    };
    InstagramAccountBuilder.prototype.withLastUpdateDate = function (date) {
        this.instagramPlugin.account.lastUpdateDate = date;
        return this;
    };
    InstagramAccountBuilder.prototype.withType = function (type) {
        this.instagramPlugin.account.type = type;
        return this;
    };
    InstagramAccountBuilder.prototype.withData = function (data) {
        this.instagramPlugin.account.data = data;
        return this;
    };
    InstagramAccountBuilder.prototype.withValid = function (valid) {
        this.instagramPlugin.valid = valid;
        return this;
    };
    InstagramAccountBuilder.prototype.build = function () {
        return this.instagramPlugin;
    };
    return InstagramAccountBuilder;
}());
export { InstagramAccountBuilder };
//# sourceMappingURL=instagram-account-builder.js.map